module.exports = __webpack_public_path__ + "img/disqus.34ae222a.jpg";